import React, { useCallback } from "react";
import { Button, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import i18n from "i18next";
import "./_audioPlugin.scss";

const AudioPlugin = ({ soundList, navItemSelected, category, onAudioSelect }) => {
  const handleAudioClick = useCallback(
    (audio, index) => {
      if (onAudioSelect) {
        onAudioSelect(audio, index);
      }
    },
    [onAudioSelect]
  );

  if (category !== "audio") {
    return null;
  }

  const currentSceneSounds =
    soundList && soundList[navItemSelected] && Array.isArray(soundList[navItemSelected])
      ? soundList[navItemSelected]
      : [];

  return (
    <Col id="audioRibbon" md={12} xs={12}>
      <div id="insideAudioRibbon">
        <div id="audioList" style={{ textAlign: "center" }}>
          {currentSceneSounds.length === 0 ? (
            <div className="noAudioMessage">
              <Button variant="primary" onClick={() => handleAudioClick(null, -1)}>
                <i className="material-icons">add</i>
                {i18n.t("Sound.add_sound")}
              </Button>
            </div>
          ) : (
            <React.Fragment>
              <Button
                className="addAudioButton"
                variant="primary"
                onClick={() => handleAudioClick(null, -1)}
              >
                <i className="material-icons">add</i>
                {i18n.t("Sound.add_sound")}
              </Button>
              {currentSceneSounds.map((audio, index) => {
                if (!audio) return null;
                const audioName =
                  audio?.name ||
                  (audio?.file && typeof audio.file === "string"
                    ? audio.file.split("/").pop()
                    : "") ||
                  `${i18n.t("Audio")} ${index + 1}`;
                return (
                  <div key={index} className="audioItem">
                    <Button
                      className="audioButton"
                      size="lg"
                      onClick={() => handleAudioClick(audio, index)}
                    >
                      <i className="material-icons">audiotrack</i>
                      <div className="audioInfo">
                        <span className="audioName">{audioName}</span>
                        {audio?.type === "narration" && (
                          <span className="audioType">{i18n.t("Sound.Sound")}</span>
                        )}
                      </div>
                    </Button>
                  </div>
                );
              })}
            </React.Fragment>
          )}
        </div>
      </div>
    </Col>
  );
};

AudioPlugin.propTypes = {
  category: PropTypes.string.isRequired,
  soundList: PropTypes.object,
  navItemSelected: PropTypes.string,
  onAudioSelect: PropTypes.func,
};

export default AudioPlugin;
